<cms-modal-layout>
  <span title>What is an authenticator code?</span>
  <div content class="code-info">
    <p>
      An authenticator code is a 6-digit code generated for your CMS account by your authenticator
      app or browser extension. You need it, together with your Username and Password, each time
      you log in.
    </p>

    <div class="code-info-section">
      <h3>How to find your code</h3>
      <div class="code-info-options">
        <div class="code-info-option">
          <div class="code-info-option-title">
            <span class="material-icons">smartphone</span>
            <span>On your phone</span>
          </div>
          <ol>
            <li>
              Open your authenticator app, such as Google Authenticator or Microsoft Authenticator.
            </li>
            <li>Find the CMS account in the list.</li>
            <li>The 6-digit number shown for it is your current code.</li>
          </ol>
        </div>
        <div class="code-info-option">
          <div class="code-info-option-title">
            <span class="material-icons">computer</span>
            <span>On your computer</span>
          </div>
          <ol>
            <li>
              Open the authenticator extension in your browser, such as Authenticator
              (authenticator.cc) for Chrome, Edge or Firefox.
            </li>
            <li>Find the CMS account in the extension.</li>
            <li>The 6-digit number shown for it is your current code.</li>
          </ol>
        </div>
      </div>
      <p>The code changes every 30 seconds.</p>
    </div>

    <div class="code-info-section">
      <h3>What to do with it</h3>
      <ol>
        <li>
          Enter all six digits exactly as shown, including any leading zero (for example, 021837,
          not 21837).
        </li>
        <li>
          Click <strong>Log in</strong> before the code changes. If it is not accepted, wait for a
          new code and enter it.
        </li>
      </ol>
    </div>

    <div class="code-info-note">
      <strong>Changed or lost your phone?</strong> Click <strong>Can’t use authenticator</strong> on
      the login page to restore access using your registered email and current password. Still need
      help? Contact <a [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>.
    </div>
  </div>
  <span closeBtnTitle>Close</span>
</cms-modal-layout>
